export function getThumbSize(
    minScrollbarLength,
    maxScrollbarLength,
    thumbSize
) {
    if (minScrollbarLength) {
        thumbSize = Math.max(thumbSize, minScrollbarLength);
    }
    if (maxScrollbarLength) {
        thumbSize = Math.min(thumbSize, maxScrollbarLength);
    }
    return thumbSize;
}
